/**
 * micro:bit 라디오 광장 입장(PICNIC-MB-FIELD-001 §6 2단계 · 제어 평면 C-07 · Bearer · 같은 코스 학생 · 교사):
 *   POST /api/courses/{c}/microbit/radio → {wsUrl, token, expiresAt}(토큰 aud picnic-field-mbradio · 5분)
 * 셸은 wsUrl 로 Colyseus joinOrCreate("mbradio", {token, course}) — 방은 코스마다 하나(룸 서버가 토큰의 코스와 맞춘다).
 */
import { useMemo } from "react";
import { useSession, useSessionManager } from "../../../store/session/SessionProvider";

export interface RadioTicket {
  readonly wsUrl: string;
  readonly token: string;
  readonly course: string;
}

export interface RadioApi {
  ticket(): Promise<RadioTicket>;
}

export function useRadioApi(): RadioApi | null {
  const manager = useSessionManager();
  const state = useSession();
  const courseId = state.status === "ready" ? state.session.courseId : null;
  return useMemo(() => {
    if (!courseId) return null;
    return {
      async ticket() {
        const r = await manager.request<unknown>(`/api/courses/${encodeURIComponent(courseId)}/microbit/radio`, { method: "POST" });
        const o = (r ?? {}) as { wsUrl?: unknown; token?: unknown };
        if (typeof o.wsUrl !== "string" || typeof o.token !== "string") throw new Error("radio ticket");
        return { wsUrl: o.wsUrl, token: o.token, course: courseId };
      },
    };
  }, [manager, courseId]);
}
